<template>
  <div id="app">
    <b-container class="bv-example-row">
      <b-row align-v="center" class="assemble-row" :class="{'mobile' : mobile}">

        <b-col class="text-center">
          <span class="inventory" @click="toInventory()">
            <b v-if="inventoryMode">인벤토리 모드</b>
            <span v-else>인벤토리 모드</span>
          </span>
          <span class="search all" @click="searchClick(false)">
            전체
          </span>
          <span @click="searchClick(letter)" :class="{'mobile' : mobile}" class="search" v-for="letter in searchLetters" :key="letter">
            <b v-if="letter == searchLetter">{{ letter }}</b>
            <span v-else>{{ letter }}</span>
          </span>
        </b-col>
      </b-row>
      <div style="margin-bottom:30px" v-if="inventoryMode && inventory.length" >
        <span class="reset" @click="setremoveall()">
          [리셋]
        </span>
      </div>
       <b-row v-if="inventoryMode" style="margin-bottom:14px">
        <b-col :lg="3" >
          
          <div class="character-div-0" v-for="(character, index) in inventory" :key="index">
            <img class="character" @click="setremove(character)"  :src="require(`@/assets/characters/${character.name}.png`)" />
          </div>
        </b-col>
        <b-col :lg="8" >
          <div class="character-div-0" style="width: 100%" v-for="(character, index) in avail" :key="index">
            <img class="character" :src="require(`@/assets/characters/${character.name}.png`)" />
            =
            <div class="character-div-0" v-for="(ingridient, index2) in character.ingridients" :key="index2">
              <img class="character" :src="require(`@/assets/characters/${ingridient}.png`)" />
              <span v-if="index2 != character.ingridients.length - 1">
                +
              </span>
            </div>
          </div>
        </b-col>
      </b-row>
       <b-row>

         <b-col :lg="tierDiv[index]" v-for="(item, index) in selectedCharacter.tier - 1" :key="index">
          <div :class="['character-diva']" v-for="(c, ci) in getBlockCount(getChildren(index))" :key="c">
             <div :style="{ marginBottom: getMarginBottom(character, index) }" :class="['character-div-' + index + ' ' + (ci + index2), character.sp ? 'nomargin': '']" 
              v-for="(character, index2) in getBlock(ci, getChildren(index))" :key="index2">
              <div v-if="character.name">
                <img class="character" @click="setWaypoint(character)"  :src="require(`@/assets/characters/${character.name}.png`)" />
              </div>
              <div v-else class="character-empty">
              </div>
            </div>
          </div>
        </b-col>


        <b-col :lg="tierDiv[(selectedCharacter.tier - 1) + index]" v-for="(item, index) in (5 - (selectedCharacter.tier - 1))" :key="'asd' + index">
          <div class="character-div" @click="setWaypoint(character)" v-for="character in filterLetter(filterBytier((selectedCharacter.tier - 1) + index + 1))" :key="character.name">
            <img :class="{ 'disabled': isDisabled(character)}" @click="addCharacter(character)" class="character"   :src="require(`@/assets/characters/${character.name}.png`)" />
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import characters from './characters'
import * as hangul from 'hangul-js'

export default {
  name: 'app',
  data () {
    return {
      searchLetter: false,
      searchLetters: [
        'ㄱ', 'ㄴ','ㄷ', 'ㄹ','ㅁ', 'ㅂ','ㅅ', 'ㅇ','ㅈ', 'ㅊ','ㅋ', 'ㅌ','ㅍ', 'ㅎ',
      ],
      selectedCharacter: {
        first: true,
        tier: 1
      },
      go: false,
      characters: characters.data,
      inventory: [],
      waypointCharacter: {},
      mapToWaypointCharacter: [],
      tierDiv: [ 3, 2, 2, 2, 3 ],
      assembleCharacter: false,
      inventoryMode: false,
      avail : [],
      mobile : false
    }
  },
  computed: {
  },
  created() {
    let uri = window.location.href.split('?');
    if (uri.length == 2)
    {
      let vars = uri[1].split('&');
      let getVars = {};
      let tmp = '';
      vars.forEach(function(v){
        tmp = v.split('=');
        if(tmp.length == 2)
        getVars[tmp[0]] = tmp[1];
      });
      
      if (getVars && getVars.mobile === "true") {
        this.mobile = true
      }
    }
  },
  methods: {
    setremoveall() {
       this.inventory =[]
      this.getAllAvailableFromInventory()
    },
    setremove(character) {
      const idx = this.inventory.indexOf(character)
      if (idx > -1) this.inventory.splice(idx, 1)
      this.getAllAvailableFromInventory()
    },
    hasAll(characters) {
      var counter = 0;
      var inventoryClone = JSON.parse(JSON.stringify( this.inventory ))
      characters.forEach(character => {
        let has = inventoryClone.some(inventoryCharacter => {
          if (inventoryCharacter.name == character) {
            const idx = inventoryClone.indexOf(inventoryCharacter)
            if (idx > -1) inventoryClone.splice(idx, 1)
            return true
          }
          return false
        })
        if (has) {
          counter ++
        }
      })
       /* eslint-disable no-console */
      // console.log(counter)
      return counter == characters.length
    },
    getAllAvailableFromInventory() {
      this.inventoryMode == false
      this.avail = []
      this.characters.forEach(character => {
        if (character.ingridients) {
          if (this.hasAll(character.ingridients)){
            this.avail.push(character)
          }
        }
      })
    },
    toInventory() {
      if (!this.inventoryMode) {
        this.searchClick(false)
      }
      this.inventoryMode = !this.inventoryMode
    },
    filterLetter(list) {
      if (!this.searchLetter) 
        return list
      return list.filter(item => hangul.disassemble(item.name)[0] == this.searchLetter);
    },
    searchClick(letter) {
       /* eslint-disable no-console */
      this.searchLetter = letter
      this.setWaypoint(false)
    },
    getMarginBottom(character, index) {
      let d = 270
      /* eslint-disable no-console */
      //console.log(index) 
      if (index != 3) {
        return 
      }
       
      let s = character.children.filter(character => !character.sp).length
      let f = (s * d  == 810) ? 810 - 90 : s * d 
      return f + "px"
    },
    isDisabled(character) {
      if (this.selectedCharacter.first  || this.selectedCharacter.name == character.name)
        return false

      /* eslint-disable no-console */
      //console.log(character) 
      return !characters.method.cango(this.selectedCharacter, character)
    },
    getBlockCount(map) {
      let c = 0;
     
      map.forEach(character => {
        if (character.invisible) {
          c ++
        }
      })
      return c
    },
    getBlock(index, map) {
      let c = 0;
      let blocks = []
      map.forEach(character => {
        if (character.invisible) {
          c ++
        } else {
          if (c == index) {
            blocks.push(character)
          }
        }
      })

      /* eslint-disable no-console */
      //console.log(blocks, index)

      return blocks
    },
    getChildren(index) {
      let map = []
      characters.method.map2(this.selectedCharacter, map, index, this.selectedCharacter.tier - 1)
     
     
      return map
    },
    filterBytier(n) {
      return this.characters.filter(character => character.tier == n)
    },
    isInMap(character) {
      return this.mapToWaypointCharacter.indexOf(character.name) > -1 || character.tier == 1
    },
    setWaypoint(character) {
      if (!character) {
        this.selectedCharacter = {
          first: true,
          tier: 1
        }
        return
      }
      if (this.inventoryMode) {
        this.inventory.push(character)
        this.getAllAvailableFromInventory()
        return
      }

      this.searchLetter = false
      character.children = []
      characters.method.format(character)
      this.selectedCharacter = character
      this.go = characters.method.go(character)
      /* eslint-disable no-console */
      console.log(character)


    },
    assemble() {
      let character = characters.method.assemblable(this.mapToWaypointCharacter, this.inventory, this.waypointCharacter)

      this.assembleCharacter = character
    },

    removeCharacter(character) {
      this.$set(this.inventory, character.name, this.inventory[character.name] - 1)

      this.assemble();
    },
    addCharacter(character, removeCharacters = []) {
      if (this.inventory[character.name])
        this.$set(this.inventory, character.name, this.inventory[character.name] + 1)
      else
        this.$set(this.inventory, character.name, 1)
      
      removeCharacters.forEach(element => {
        this.removeCharacter({
          name: element
        })
      })
      this.assemble()
    }
  },
  components: {
    
  }
}
</script>

<style>
.bv-example-row {
  max-width:100% !important
}
.assemble-row {
  height: 100px;
}
.assemble-row.mobile {
  height: 80px;
}

.character {
  width: 80px;
  height: 80px;
  margin-right: 5px;
  margin-left: 5px;
  margin-top: 5px;
  margin-bottom: 5px;
}
.disabled {
  opacity: 0.25;
}
.character-div {
   display: inline-block;
  position: relative;
}
.character-div-0-no{
  display: inline-block;
  position: relative;
}
.character-div-0{
  display: inline-block;
  position: relative;
}
.character-div-2{
  display: block;
  position: relative;
  margin-bottom: 180px
}

.nomargin {
  margin-bottom: 0px !important
}

/* .character-div-3{
  display: block;
  position: relative;
  margin-bottom: 720px;
} */
.character-div-4{
  display: block;
  position: relative;
}

.character-div-2-180 {
  margin-top: 180px
}

.closex{
    position: absolute;
    font-size: 20px;
    left: 70px;
    top: 0px;
    color: black;
    font-weight: bold;
}
.waypoint{
    position: absolute;
    font-size: 20px;
    left: 10px;
    top: 0px;
    color: black;
    font-weight: bold;
}
.counter{
    position: absolute;
    font-size: 35px;
    left: 35px;
    top: 10px;
    color: black;
    font-weight: bold;
}
.character-empty{
  height: 90px;
}
.search {
  display: inline-block;
  padding: 5px;
  font-size:50px;
   cursor: pointer;
}
.search.mobile {
   font-size:35px !important;
}
.search.all {
  font-size:30px !important;
  margin-right: 30px;
}
.inventory{
  font-size:23px;
   margin-right: 45px;
    cursor: pointer;
}
.reset {
  font-size: 25px;
  padding: 5px;
  cursor: pointer;
}
</style>
